// extracted by mini-css-extract-plugin
export default {"copyToast":"CopyToast_copyToast__by4BT","show":"CopyToast_show__Palzf"};